import React from "react"
import { Modal, Paper } from "@mui/material"
import ConfirmDialogLayout from "../../../common/layouts/ConfirmDialogLayout"

export default function ConfirmDeleteOperatorEmergencyReservationModal(props: {
    isOpen: boolean,
    onConfirm: Function,
    onClose: Function
}) {

    return (
        <Modal
            open={props.isOpen}
            onClose={() => props.onClose()}
        >
            <Paper
                sx={{
                    position: "absolute",
                    width: "500px",
                    top: "50%",
                    left: "50%",
                    transform: "translate(-50%, -50%)",
                    padding: 2
                }}
            >
                <ConfirmDialogLayout
                    title="Delete Operator Emergency Reservation"
                    message="Are you sure you want to delete this operator emergency reservation?"
                    onConfirm={props.onConfirm}
                    onClose={props.onClose}
                />
            </Paper>
        </Modal>
    )
}